// =============================================================================
// EdamamAttribution — the attribution Edamam's terms require wherever its data is shown
// =============================================================================
// Edamam (all plans): "All Edamam plans require the following attribution by using the image
// provided here and a link to http://developer.edamam.com … Not providing attribution is
// considered breach of contract" (developer.edamam.com, read 2026-11-02). The badge must be one of
// Edamam's own four graphics (developer.edamam.com/attribution), placed in the section that shows
// the data. Minimum required — Vincent 2026-11-02.
// Self-hosted, unmodified: developer.edamam.com/images/transparent.svg redirects to a short-lived
// presigned S3 download that our img-src CSP blocks, so a hot-link rendered only the alt text
// (verified on Prod 2026-11-03). Same pattern as /assets/instacart-carrot.svg.
import React from 'react';

export const EDAMAM_BADGE_URL = '/assets/edamam-badge.svg';
export const EDAMAM_LINK = 'https://developer.edamam.com';

export default function EdamamAttribution({ className = '' }) {
  return (
    <a
      className={`edamam-attribution ${className}`.trim()}
      href={EDAMAM_LINK}
      target="_blank"
      rel="noopener noreferrer"
      title="Nutrition data powered by Edamam"
    >
      <img src={EDAMAM_BADGE_URL} alt="Powered by Edamam" />
    </a>
  );
}
